/* eslint-disable no-eval */
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Button, Card, CardBody, CardTitle, Col, FormGroup, Label, ListGroup, ListGroupItem, ListGroupItemHeading, Row, Spinner } from "reactstrap";
import * as Yup from "yup";
import Error from "../../components/messagesModal/error";
import Success from "../../components/messagesModal/success";
import BaseService from "../../services/baseService";
import Validation from "../../utils/validation";
import { actions as actionsSite } from "../../redux/actions/site";

import "./consultas-produtos.scss";
import { ErrorMessage, Field, Formik } from "formik";

const ConsultasProdutos = () => {
  new Validation(Yup);
  const baseService = new BaseService("grupo-consulta");
  const profile = useSelector((state) => state.auth.profile);

  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState({});
  const [validationSchema, setValidationSchema] = useState({});
  const [query, setQuery] = useState(null);
  // const [price, setPrice] = useState(null);
  const [message, setMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const showMessageModal =  useCallback(({ error, msg }) => {
    const configModal = {
      component: error ? <Error msg={msg} /> : <Success msg={msg} />,
      title: error ? `Erro` : `Sucesso`,
    };
    dispatch(actionsSite.setModal(configModal));
  },[dispatch]);

  const getQueryCode = useCallback(() => {
    const code = location.pathname.split("/").pop();
    return code;
  },[location]);

  const getQueryGroup = useCallback(async () => {
    const code = getQueryCode();
    const query = profile.queryGroups.find((q) => q.code === code);
    return query;
  },[profile, getQueryCode]);

  useEffect(() => {
    const run = async () => {
      setMessage(null);
      setLoading(true);
      const _query = await getQueryGroup();
      if (_query) {
        // const _price = await getQueryPrice(_query);
        setQuery(_query);
        // setPrice(_price);

        setLoading(false);
      } else {
        showMessageModal({ error: true, msg: "Consulta não encontrada" });
        history.push("/dashboard");
      }
    };

    run();
  }, [location, getQueryGroup, history, showMessageModal]);

  useEffect(() => {
    const run = async () => {
      const fields = {};
      const fieldsValidation = {};
      if (query) {
        for (let q of query.input) {
          fields[q.field] = "";
          fieldsValidation[q.field] = Yup.string();
          if (q.validation) {
            fieldsValidation[q.field] = fieldsValidation[q.field][q.validation](`Campo ${q.label} é inválido`);
          }
        }
        setInitialValues(fields);

        const validationSchema = Yup.object().shape(fieldsValidation);
        setValidationSchema(validationSchema);
      }
    };
    run();
  }, [query]);

  const getLabelField = (input) => {
    return query.input.find((e) => e.field === input)?.label;
  };



  // const getQueryPrice = async (query) => {
  //   const _query = profile.clientPrice.queries.find((price) => price.query === query._id);

  //   return _query.price;
  // };

  // const _validatePrePost = (values) => {
  //   console.log("validatePrePost");
  //   console.log("values", values);
  //   if (query.inputsRequired) {
  //     let inputsRequired = query.inputsRequired;
  //     const validates = {};
  //     console.log(
  //       "query.inputsRequired.split(/|||&&/gi)",
  //       query.inputsRequired.split(/\|\||\&\&/gi)
  //     );
  //     for (let input of query.inputsRequired.split(/\|\||\&\&/gi)) {
  //       input = input.trim();
  //       validates[input] = values[input].length > 0;
  //       inputsRequired = inputsRequired.replace(input, `validates.${input}`);
  //     }
  //     console.log("inputsRequired", inputsRequired);
  //     console.log(eval(inputsRequired));
  //     return false;
  //     return eval(inputsRequired);
  //   }
  //   return true;
  // };

  const validatePrePost = (values) => {
    if (query.inputsRequired) {
      const inputsRequired = query.inputsRequired;
      const conditionsOr = inputsRequired.split("||").map((v) => v.trim());
      for (const cond of conditionsOr) {
        const validates = {};
        const inputs = cond.split("&&").map((v) => v.trim());
        for (const input of inputs) {
          validates[input] = values[input].length > 0;
        }
        const anyFalse = Object.values(validates).filter((e) => e === false);
        if (anyFalse.length === 0) {
          return true;
        }
      }
      return false;
    }
    return true;
  };

  const execute = async (values) => {
    try {
      if(query.code === "veicular-top-csv"){
        values["incluirPdf"]=true;
      }
      // console.log(query, values);
      const validate = validatePrePost(values);
      if (validate && !isSubmitting) {
        setMessage(null);
        setIsSubmitting(true);
        showMessageModal({ error: false, msg: "Solicitando a consulta, por favor aguarde", icon:'far fa-clock' });
        const url = `${baseService.route}/${query.code}`;
        baseService
          ._post(url, values)
          .then((res) => {
            showMessageModal({ error: !res.success, msg: !res.success ? res.msg : "Consulta solicitada com sucesso" });
            setIsSubmitting(false);

            history.push("/historico-combo/" + res.ID);
          })
          .catch((error) => {
            if (error.response) {
              showMessageModal({ error: true, msg: error.response.data.msg });
              setIsSubmitting(false);
            }
          });
      } else {
        setMessageError();
      }
    } catch (e) {
      console.log(e.toString());
    }
  };

  const setMessageError = () => {
    const inputs = query.inputsRequired;
    let messageError = "<b>Preencha os campos:</b> <br> ";
    const replacers = inputs
      .split(" ")
      .filter((a) => a.length > 0)
      .map((a) => a.trim());
    for (let replacer of replacers) {
      if (replacer.match(/\|\|/gi)) {
        messageError += " ou";
      } else if (replacer.match(/&&/gi)) {
        messageError += " e";
      } else {
        messageError += ` ${getLabelField(replacer)}`;
      }
    }

    setMessage({ text: messageError, error: true });
  };

  return (
    <div className="consultas">
      <Breadcrumb>
        <BreadcrumbItem>
          <Link to="/">Dashboard</Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Combo Consultas</BreadcrumbItem>
      </Breadcrumb>

      <Card>
        <CardBody>
          {loading ? (
            <div className="text-center">
              <Spinner color="danger" />
            </div>
          ) : (
            <React.Fragment>
              <Row>
                <Col xs="12">
                  <CardTitle>
                    <i className={query.icon}></i> {query.type} - {query.name}
                  </CardTitle>
                  <div>{query.description}</div>
                </Col>
              </Row>
              <form
                onSubmit={(event) => {
                  event.preventDefault();
                }}
              >
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={async (values) => await execute(values)}>
                  {({ errors, touched, submitForm, setFieldValue }) => (
                    <>
                      <Row>
                        {query && query.input.map((input, index) => {
                          return (
                            <Col sm={12 / query.input.length} key={index}>
                              <FormGroup>
                                <Label>{input.label}</Label>
                                <Field
                                  type="text"
                                  name={input.field}
                                  placeholder={input.placeholder || ""}
                                  className={"form-control" + (errors[input.field] && touched[input.field] ? " is-invalid" : "")}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") submitForm();
                                  }}
                                  onPaste={(e)=>{
                                    e.preventDefault();
                                    setFieldValue(input.field,e.clipboardData.getData('Text').trim())
                                  }}
                                />
                                <ErrorMessage name={input.field} component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                          );
                        })}
                      </Row>
                      <div className="d-flex justify-content-end">
                        <Button type="button" color="primary" disabled={isSubmitting} onClick={submitForm}>
                          {isSubmitting ? (
                            <>
                              <Spinner color="light" size="sm" /> Processando a consulta...
                            </>
                          ) : (
                            <>
                              <i className=" fas fa-search"></i> Enviar
                            </>
                          )}
                        </Button>
                      </div>
                      {message && (
                        <div className={`alert mt-3 ${message.error ? "alert-danger" : "alert-success"}`}>
                          <span dangerouslySetInnerHTML={{ __html: message.text }}></span>
                          <div
                            onClick={() => setMessage(null)}
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              marginRight: 10,
                              cursor: "pointer",
                              fontWeight: "bold",
                            }}
                          >
                            x
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </Formik>
              </form>
              <ListGroup>
                <ListGroupItemHeading color="light">
                  Esse produto é composto das seguintes consultas
                </ListGroupItemHeading>
                {query.queries.map((item, index) =>
                  <ListGroupItem key={index}>
                    <i className="fas fa-angle-right mr-1"></i>
                    {item.label}
                  </ListGroupItem>
                )}
              </ListGroup>
            </React.Fragment>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default ConsultasProdutos;
